module.exports = __webpack_public_path__ + "static/10_rot2-147fcb6c129e3d2a5f555d1ea9f340ae.png";